$(document).on('ready', function() {
    $.getScript("http://platform.twitter.com/widgets.js", function(){
      function handleTweetEvent(e){
        if (e) {
          addSocialEntries(e.target.dataset);
        }
      }
      twttr.events.bind('tweet', handleTweetEvent);        
    });

    $('a[data-social="facebook"]').click(function(e) {
      addSocialEntries(this.dataset);
    });

    const addSocialEntries = (data) => {
      if (typeof _ceml !== 'undefined') {
        if (_ceml != null) {
          if (data != null && typeof data !== 'undefined') {
            const settings = {
              "url": "https://yammie-api.herokuapp.com/api/v1/shop/add-social-entries",
              "method": "POST",
              "timeout": 0,
              "headers": { "Content-Type": "application/json" },
              "data": JSON.stringify({ "email": _ceml, "giveaway": data.giveaway, "social": data.social, currentGiveaway: data.currentGiveaway }),
            };
            $.ajax(settings).done(function(response) {
               if (response && response.message) {
                document.querySelector('h4.social-share-alert').innerText = response.message;

               } else {
                console.log('no message from the server');
               }
            });
          }
        }
      }
    };

});